import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { useEffect } from 'react';
import { REACT_COMPONENT_ENGAGED_TIME } from 'app/shared/constants/constants';

interface MetricData {
  average: number;
  name: string;
  sampleCount: number;
}

interface AdditionalProperties {
  [key: string]: string;
}

export const createDefaultMetricData = (customValues = {}) => {
    const defaultMetricData = {
      average: 5,
      name: REACT_COMPONENT_ENGAGED_TIME,
      sampleCount: 1,
    };

    return { ...defaultMetricData, ...customValues };
  };

export const useTrackPageViewAndMetrics = (
  pageName: string,
  metricData: MetricData,
  additionalProperties: AdditionalProperties = {},
) => {
  const appInsights = useAppInsightsContext();

  useEffect(() => {
    if (!appInsights) return;
    // Track Page View
    appInsights.trackPageView({ name: pageName });
    // Track Metric
    appInsights.trackMetric(metricData, additionalProperties);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
    // Track Metric
    return appInsights;
  };
